// src/components/ui/WhiteSpinner.jsx
import PropTypes from 'prop-types'
import { cn } from '../../utils/cn'

const WhiteSpinner = ({ 
  className = '',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  }

  return (
    <div className={cn(
      "border-2 border-white border-t-transparent rounded-full animate-spin",
      sizeClasses[size],
      className
    )} />
  )
}

WhiteSpinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
}

export default WhiteSpinner
